import { render } from "./MonitoringPage.vue?vue&type=template&id=2e6ab396&scoped=true&ts=true"
import script from "./MonitoringPage.vue?vue&type=script&lang=ts"
export * from "./MonitoringPage.vue?vue&type=script&lang=ts"

import "./MonitoringPage.vue?vue&type=style&index=0&id=2e6ab396&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6ab396"]])

export default __exports__